export default __webpack_public_path__ + "static/outline-9798b5286eb993fd9613e9376d78aa88.png";